export default __webpack_public_path__ + "files/media/nysf-google-hd.43ca5683.jpg";